module.exports = __webpack_public_path__ + "assets/img/13_1010_big.8d0a6e91.jpg";